const SettingsPage = {
  title: '服务更新',
  updateEntrance: '服务版本升级',
  autoUpdateTitle: '服务自动升级',
  autoUpdageSubTitle: '开启后，系统会选择在设备负载低时，自动进行升级。',
}

const ServiceListPage = {
  title: '服务版本',
  updateAll: '更新全部',
  system: '系统版本',
  xos: '系统版本',
  xl_gx: '共享服务',
  xl_disk: '磁盘管理',
  xl_shell: '文件管理',
  xl_thumb: '转码服务',
  xl_dcdn: '传输服务',
  xl_thunder: '取回服务',
  xl_scrape: '索引服务',
  xl_backer: '备份服务',
  xl_pan: '网盘服务',
  description: {
    xl_gx: '服务支持Samba协议访问设备，允许写入、上传、删除、修改等。',
    xl_disk: '服务支持磁盘的读写、格式化、挂载等基础能力。',
    xl_shell: '服务支持文件的查看、移动、复制、新建等基础功能。',
    xl_thumb: '服务支持视频、音频、图片文件，在复杂网络条件下流畅预览、播放。',
    xl_dcdn: '服务支持基础上传、下载功能。',
    xl_thunder: '使用迅雷下载技术，提供高速传输功能。',
    xl_scrape: '服务将提取文件属性，便于快速访问内容信息。',
    xl_backer: '服务将磁盘文件加密存储至云端，保障磁盘数据内容的安全。',
    xl_pan: '用于提供云盘下载、备份等相关服务，支持第三方云盘。',
  },
}

const lang = {
  SettingsPage,
  ServiceListPage,
}

export default lang
